<template>
  <ErrorDisplay />
</template>

<script>
import { postHeight } from '@/assets/js/mixins';
import ErrorDisplay from '@/components/ErrorDisplay';

export default {
  components: {
    ErrorDisplay,
  },
  mixins: [postHeight],
};
</script>
